<template>
    <v-container>
      <v-dialog
          max-width="440"
          v-model="consentDialogOpen"
      >
        <v-card
            class="d-flex align-center py-5 px-5 ga-1"
            rounded
        >
          <div class="w-100 d-flex justify-end">
            <v-btn @click="consentDialogOpen = false" icon="close" variant="text" size="small" density="comfortable" color="grey-darken-1"/>
          </div>
          <div class="text-h5">
            {{ $t('gamification.privacy_policy_headline') }}
          </div>
          <div class="text-grey-darken-1 pt-5">
            {{ $t('gamification.privacy_policy_paragraph') }}
            <a class="text-grey-darken-1" target="_blank" href="https://mendelu.cz/o-univerzite/uredni-deska/informace-o-zpracovani-osobnich-udaju-gdpr/"> {{ $t('gamification.privacy_policy_link') }} </a>
          </div>
          <div class="d-flex flex-row ga-2 pt-7">
            <v-btn @click="setConsent(false)" :loading="loading" color="primary" variant="text" rounded>{{ $t('gamification.not_allow') }}</v-btn>
            <v-btn @click="setConsent(true)" :loading="loading" color="primary" variant="flat" rounded>{{ $t('gamification.allow') }}</v-btn>
          </div>
          <div>

          </div>
        </v-card>
      </v-dialog>

        <TestingLight />
        <v-row justify="center">
            <v-col cols="auto">
                <h1>{{ $t('gamification.dashboard_welcome_title') }}</h1>
            </v-col>
        </v-row>
        <v-row justify="center" no-gutters>
            <v-col cols="auto">
                <p>{{ $t('gamification.dashboard_welcome_subtitle') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center" no-gutters class="mt-5">
            <v-col cols="auto">
              <v-btn
                  @click="goToSubjectsPage"
                  :loading="loading"
                  color="primary"
                  rounded
                  variant="flat"
              >
                {{ $t('gamification.to_subjects_btn') }}
              </v-btn>
            </v-col>
        </v-row>
        <v-row justify="center" class="mt-10">
            <v-col cols="auto">
                <h2>{{ $t('gamification.tutorial_heading') }}</h2>
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="12" md="4">
                <v-card
                    class="pa-4"
                    elevation="0"
                    border
                >
                    <v-row>
                        <v-col cols="auto">
                            <AddSubject />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h2>{{ $t('gamification.adding_subject_headline') }}</h2>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <p>{{ $t('gamification.adding_subject_paragraph') }}</p>
                      </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card
                    class="pa-4"
                    elevation="0"
                    border
                >
                    <v-row>
                        <v-col cols="auto">
                            <AddTest />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h2>{{ $t('gamification.creating_questions_headline') }}</h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>{{ $t('gamification.creating_questions_paragraph') }}</p>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card
                    class="pa-4"
                    elevation="0"
                    border
                >
                    <v-row>
                        <v-col cols="auto">
                            <TestCreation/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h2>{{ $t('gamification.creating_test_headline') }}</h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>{{ $t('gamification.creating_test_paragraph') }}</p>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

      <v-row justify="center">
        <v-col align-self="start" cols="12" md="4">
          <v-card
              class="pa-4"
              elevation="0"
              border
          >
            <v-row>
              <v-col cols="auto">
                <ActiveTest />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h2>{{ $t('gamification.creating_seminar_headline') }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p>{{ $t('gamification.creating_seminar_paragraph') }}</p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
              class="pa-4"
              elevation="0"
              border
          >
            <v-row>
              <v-col cols="auto">
                <SeminarActivation />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h2>{{ $t('gamification.seminar_activation_headline') }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p>{{ $t('gamification.seminar_activation_paragraph') }}</p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
        <v-row justify="center" no-gutters class="mt-5 mb-5">
            <v-col cols="auto">
                <LightButton @click="$router.push({name:'support'})">{{ $t('gamification.have_question') }}</LightButton>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import TestingLight from '../../assets/gamification/testing_light.svg?component';
import AddSubject from '../../assets/gamification/add_subject_light.svg?component';
import AddTest from '../../assets/gamification/add_test_light.svg?component';
import ActiveTest from '../../assets/gamification/active_test_light.svg?component';
import SeminarActivation from '../../assets/gamification/seminar_activation.svg?component'
import TestCreation from '../../assets/gamification/test_creation.svg?component'
import LightButton from "../../components/buttons/LightButton";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'GamificationDashboard',

  components: {
      LightButton,
      TestingLight,
      AddSubject,
      AddTest,
      ActiveTest,
      SeminarActivation,
      TestCreation
  },
  data(){
    return {
      loading: false,
      consentDialogOpen: false
    }
  },
  async mounted() {
    this.loading = true
    try {
      await this.getMyConsent()
    } catch (e) {
      console.error('error ', e)
    }
    this.loading = false
  },
  methods: {
    ...mapActions('ConsentGDPR',['getMyConsent','saveConsent']),

    goToSubjectsPage(){
      if(this.consent.hasAccepted != null){
        this.$router.push({name: 'Subjects'})
      } else {
        this.consentDialogOpen = true
      }
    },
    async setConsent(hasAccepted){
      this.loading = true
      try {
        await this.saveConsent({
          hasAccepted: hasAccepted,
          web: hasAccepted
        })
        await this.$router.push({name: 'Subjects'})
      } catch (e) {
        console.error('error ', e)
      }
      this.loading = false
    }

  },
  computed: {
    ...mapGetters('ConsentGDPR',['consent'])
  }

}
</script>
<style scoped>

    h1, p, h2 {
        color: #3F4349;
    }

    .v-card {
        border-radius: 8px !important;
        height: 100%;
    }
</style>